export default __webpack_public_path__ + "static/media/TRIP SIMULATOR IN OVER LOAD CIRCUIT.714057af.JPG";